import { Period } from "revlock-webutils";
import shortid from "shortid";

export default {
    buildPlan: function buildPlan(startDate, endDate, planAmount, ssp, retailCalenderConfig) {
        if (!startDate)
            throw new Error("Need start date for POINT_IN_TIME plan");

        const startActgPeriod = Period.toActgPeriod(startDate, retailCalenderConfig)
        const endActgPeriod = endDate ?
            Period.toActgPeriod(endDate, retailCalenderConfig):
            null;

        const plan = []
        plan.push({
            id: shortid.generate(),
            actgPeriod: startActgPeriod,
            postingDate: startActgPeriod.postingDate,
            planAmount,
            effectiveDate: startActgPeriod.endDate,
            //todo @irfan shouldn't this be the date of the point in time?
            period: startActgPeriod.period,
            postingPeriod: startActgPeriod.period,
            percentRecognized: 1.0,
            cummulativeTotal: planAmount,
            cummulativePercentRecognized: 1.0
        });

        // fill the gap periods between startDate and endDate if provided.
        if(!endActgPeriod)
            return plan;

        const missingPeriods =
            Period.periodsBetween(startActgPeriod.period,
                endActgPeriod.period, false, true);

        let actgPeriod = startActgPeriod;
        missingPeriods.forEach(period => {
            actgPeriod = actgPeriod.get(period)

            plan.push({
                id: shortid.generate(),
                actgPeriod,
                postingDate: actgPeriod.postingDate,
                effectiveDate: actgPeriod.endDate,
                period: actgPeriod.period,
                postingPeriod: actgPeriod.period,
                planAmount: 0,
                percentRecognized: 0,
                cummulativeTotal: planAmount
            });
        });

        if (ssp.recognizedOn === 'endDate') {
            // make starting point zero
            plan[0].planAmount = 0;
            plan[0].percentRecognized = 0;
            plan[0].cummulativeTotal = 0;
            plan[0].cummulativePercentRecognized = 0;

            plan[plan.length - 1].planAmount = planAmount;
            plan[plan.length - 1].percentRecognized = 1.0;
            plan[plan.length - 1].cummulativeTotal = planAmount;
            plan[plan.length - 1].cummulativePercentRecognized = 1.0;
        }

        return plan;
    }
}
